import { useSelector } from "react-redux";

export function useArchivedStudentLists() {
  return useSelector((state) => state.archivedStudentLists);
}
